
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[accountUuid]",
      function () {
        return require("private-next-pages/[accountUuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[accountUuid]"])
      });
    }
  